"use strict";

/**
 *  平台设置
 *  @module 基本属性
 */

import Vue from "@/main";

// 默认数据
const form = {
  transparency: false, //选择模型时设置透明度
  property: false, //点击模型时查看其属性
  isShowComponent: false, //点击模型时查看其构件属性列表
  eagleEyeMap: false, //默认显示鹰眼地图
  networkDelay: true, //默认显示延迟与帧数
};

// 保存提交 (存储至localStorage)
const saveBasicSettings = (data) => {
  localStorage.setItem("basicSettings", JSON.stringify(data));
};

// 对外暴露基本属性 / 取消保存
const exposureBasicSettings = () => {
  if (localStorage.getItem("basicSettings")) {
    return JSON.parse(localStorage.getItem("basicSettings"));
  } else {
    localStorage.setItem("basicSettings", JSON.stringify(form));
    return JSON.parse(JSON.stringify(form));
  }
};

// 处理效果
const setBasicEffect = (data, map = Vue.$GLOBAL.map) => {
  const { eagleEyeMap, networkDelay } = data;
  // 延迟与帧数
  map.viewer.scene.debugShowFramesPerSecond = networkDelay;
  // 鹰眼地图
  if (eagleEyeMap) {
    if (!Vue.$GLOBAL.overviewMap) {
      Vue.$GLOBAL.overviewMap = new mars3d.control.OverviewMap({
        basemap: {
          name: "高德电子",
          icon: "/img/basemaps/gaode_vec.png",
          type: "gaode",
          layer: "vec",
          show: true,
        },
        rectangle: {
          color: "#fecd78",
          opacity: 0.2,
          outline: 1,
          outlineColor: "#ff7800",
        },
        style: {
          left: "384px",
          bottom: "6px",
          width: "200px",
          height: "150px",
        },
      });
      map.addControl(Vue.$GLOBAL.overviewMap);
    }
  } else {
    if (Vue.$GLOBAL.overviewMap) {
      map.removeControl(Vue.$GLOBAL.overviewMap, true);
    }
    Vue.$GLOBAL.overviewMap = undefined;
  }
};

export { saveBasicSettings, exposureBasicSettings, setBasicEffect };
